// Follow-ups trimestrais: deixaram de ser fases do projeto e passaram a TAREFAS do comercial,
// a cada 3 meses desde o início do contrato (só datas de hoje em diante e até ao fim do contrato).
export const ehFollowup = (nome) => /follow.?up/i.test(nome || '');
export const TEXTO_FOLLOWUP = 'Follow-up trimestral';
export const DIAS_ANTES_FOLLOWUP = 20;
// a tarefa de follow-up só aparece ao comercial nos 20 dias antes da data (e depois, se ficar por fazer)
export const followupVisivel = (t, hojeIso) => {
  if (!t || t.feita || !String(t.texto || '').startsWith(TEXTO_FOLLOWUP) || !t.data_lembrete) return true;
  const lim = new Date(hojeIso || new Date().toISOString().slice(0, 10)); lim.setDate(lim.getDate() + DIAS_ANTES_FOLLOWUP);
  return String(t.data_lembrete).slice(0, 10) <= lim.toISOString().slice(0, 10);
};

const iso = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
const maisMeses = (isoIni, n) => { const [y, m, d] = isoIni.slice(0, 10).split('-').map(Number); const x = new Date(y, m - 1 + n, 1); const ult = new Date(x.getFullYear(), x.getMonth() + 1, 0).getDate(); x.setDate(Math.min(d, ult)); return iso(x); };

export async function criarFollowups(supabase, projectId) {
  try {
    const { data: p } = await supabase.from('projects')
      .select('id,name,contract_start,contract_end,commercial_email,commercial_name,is_mae').eq('id', projectId).single();
    if (!p || p.is_mae || !p.commercial_email || !p.contract_start || !p.contract_end) return 0;
    const hoje = iso(new Date());
    const datas = [];
    for (let n = 1; n <= 40; n++) { const d = maisMeses(p.contract_start, 3 * n); if (d > String(p.contract_end).slice(0, 10)) break; if (d >= hoje) datas.push(d); }
    if (!datas.length) return 0;
    const [{ data: fases }, { data: ja }, { data: u }] = await Promise.all([
      supabase.from('project_phases').select('id,name,order_num').eq('project_id', p.id).order('order_num'),
      supabase.from('project_tarefas').select('data_lembrete').eq('project_id', p.id).ilike('texto', TEXTO_FOLLOWUP + '%'),
      supabase.from('user_roles').select('full_name').eq('email', p.commercial_email).maybeSingle(),
    ]);
    const semFU = (fases || []).filter(f => !ehFollowup(f.name));
    const fase = semFU.find(f => /execu/i.test(f.name)) || semFU[semFU.length - 1] || null;
    const existentes = new Set((ja || []).map(t => String(t.data_lembrete).slice(0, 10)));
    const novas = datas.filter(d => !existentes.has(d)).map(d => ({
      fase_id: fase ? fase.id : null, project_id: p.id,
      texto: `${TEXTO_FOLLOWUP} — ${p.name}. Contacto de acompanhamento que se faz a cada 3 meses desde o arranque do projeto (${String(p.contract_start).slice(8,10)}/${String(p.contract_start).slice(5,7)}/${String(p.contract_start).slice(0,4)}): falar com o cliente sobre o estado do projeto, a satisfação e se há ajustes ou extensão.`,
      data_lembrete: d, autor_email: null, autor_nome: 'HUB',
      responsavel_email: p.commercial_email, responsavel_nome: u?.full_name || p.commercial_name || p.commercial_email,
    }));
    if (novas.length) await supabase.from('project_tarefas').insert(novas);
    return novas.length;
  } catch (e) { console.error('follow-ups:', e); return 0; }
}
